
















import { defineComponent, ref, onMounted } from "@vue/composition-api";
import config, { setConfig } from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIconButton from "@/components/BaseIconButton";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageFeaturesFlags",
  components: {
    BaseIconButton,
    PageTitle,
    BaseButton,
    BaseCheckbox,
    BasePage,
  },
  setup(_, { root }) {
    const features = ref(
      Object.entries(config)
        .filter(([key, value]) => key.includes("feature") && typeof value === "boolean")
        .sort((a, b) => {
          const normalizeA = a[0].toLowerCase();
          const normalizeB = b[0].toLowerCase();
          return normalizeA > normalizeB ? 1 : normalizeA < normalizeB ? -1 : 0;
        })
        .map(item => {
          return {
            name: item[0],
            value: item[1],
          };
        })
    );

    const changedFeatures = ref<Record<string, boolean>>({});

    const changeFeatures = (feature: { name: string; value: boolean }) => {
      changedFeatures.value[feature.name] = feature.value;
    };

    const saveFeatures = () => {
      localStorage.setItem("features", JSON.stringify(changedFeatures.value));
      setConfig(changedFeatures.value);
      root.$router.push({ name: "more" });
    };

    const resetFeatures = () => {
      localStorage.removeItem("features");
      location.reload();
    };
    onMounted(() => {
      const features = localStorage.getItem("features");
      if (features) {
        changedFeatures.value = JSON.parse(features);
      }
    });

    return {
      features,
      saveFeatures,
      resetFeatures,
      changeFeatures,
    };
  },
});
